import { Loader2 } from "lucide-react";

export { TaskListLoadingState } from "./TaskListLoadingState";
export type { ResearchSummary, ResearchPhase } from "./TaskListLoadingState";

interface MainLoadingStateProps {
  progressMessage?: string;
}

/**
 * Main loading state shown when the chat is initially loading or creating a new chat
 */
export function MainLoadingState({ progressMessage }: MainLoadingStateProps) {
  return (
    <div
      className="flex h-screen flex-col items-center justify-center p-8 space-y-4"
      aria-busy="true"
      aria-label="Loading conversation"
    >
      <Loader2 className="h-8 w-8 animate-spin text-primary" />
      <p className="text-sm text-muted-foreground">{progressMessage}</p>
    </div>
  );
}
